<div>
    <!-- *ngIf="proof_url?.length" -->
    <div class="tab-bg-view">
        <h6 class="font-600 mb-3">{{"Attendance prove" | translator}}</h6>
        
        <!-- Gallery Grid -->
        <div class="proof-gallery">
            <!-- Display existing proofs -->
            <div *ngFor="let proof of proof_url; let i = index" class="gallery-item">
                <div class="gallery-item-wrapper">
                    <!-- Image Preview -->
                    <div *ngIf="checkisImg(proof?.url)" class="gallery-image-container">
                        <img [src]="staticURL + proof?.url" [alt]="'Proof ' + (i + 1)" class="gallery-image" />
                        <div class="gallery-overlay">
                            <button class="gallery-delete-btn" (click)="removeProof(i)" [title]="'Delete' | translator">
                                <i class="pi pi-trash"></i>
                            </button>
                        </div>
                    </div>
                    <!-- File Preview (non-image files) -->
                    <div *ngIf="!checkisImg(proof?.url)" class="gallery-file-container">
                        <div class="gallery-file-icon">
                            <i class="pi pi-file" style="font-size: 2rem;"></i>
                        </div>
                        <div class="gallery-file-name">{{ proof?.url?.split('/').pop() }}</div>
                        <div class="gallery-overlay">
                            <button class="gallery-delete-btn" (click)="removeProof(i)" [title]="'Delete' | translator">
                                <i class="pi pi-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Upload Button (Plus Icon) -->
            <div class="gallery-item">
                <label for="proofFileInput" class="gallery-upload-btn">
                    <div class="gallery-upload-content">
                        <i class="pi pi-plus-circle"></i>
                        <span class="gallery-upload-text">{{"Upload attendance prove" | translator}}</span>
                    </div>
                    <input 
                        type="file" 
                        id="proofFileInput" 
                        (input)="addFiles($event)"
                        accept=".jpg,.jpeg,.png,.mp4,.pdf,.doc,.docx,.txt,.pptx,.ppt,.xlsx,.xls,video/*"
                        style="display: none;">
                </label>
            </div>
        </div>
        
        <!-- Upload Progress -->
        <div class="w-100 mt-3" *ngIf="fileProgress">
            <p-progressBar [value]="uploadProgress"></p-progressBar>
        </div>
    </div>
</div>

<p-table [value]="attendees" dataKey="_id" [paginator]="true" [rows]="10" [selectionPageOnly]="true"
    [tableStyle]="{'min-width': '50rem','margin':'2rem 0rem'}">
    <ng-template pTemplate="header">
        <tr>

            <th style="min-width:200px">{{"user name" | translator}}</th>
            <th style="min-width:200px">{{"Email" | translator}}</th>
            <th style="min-width:200px">{{"Phone" | translator}}</th>
            <th style="min-width:200px">{{"Attendance" | translator}}</th>

        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>

            <td style="color: black;">
                {{product.name.first +' ' + product.name.middle + ' ' + product.name.last}} {{product.attend}}
            </td>
            <td style="color: black;">
                {{product.email}}
            </td>
            <td style="color: black;">
                {{product.phone}}
            </td>
            <td>

                <p-selectButton class="v4-selectbutton" [options]="attendanceOptions" [(ngModel)]="product.status" (ngModelChange)="change(product._id,$event)" optionLabel="label"
                    optionValue="value" aria-labelledby="basic" />

            </td>
        </tr>
    </ng-template>
</p-table>

<div class="d-flex justify-content-center">
    <button type="button" (click)="saveAttendees()" class="mb-ten my-3 py-2 v4-btn-every"><i
            class="pi pi-user-edit v4-ml-2"></i>{{"Update" | translator}}</button>
</div>